export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt/nuxt-svg-icon-sprite/sprite-default.hYKIjsiarMBLrmEgrzXHnowSaKVMb8O47DiMRlZkwAA.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "add-hexagon",
  "arrow-east",
  "arrow-left",
  "arrow-right",
  "chevron-down",
  "chevron-down-marketing",
  "close",
  "download",
  "facebook",
  "instagram",
  "linkedin",
  "logo",
  "magnifyingglass",
  "newspaper",
  "paperplane",
  "play",
  "search",
  "threads",
  "twitter",
  "x_formerly_twitter",
  "youtube"
]);